@if (source != 'crc') {
    <lh-navigation-layout-page
        sourceItem="communication"
        title="{{ initData.content.title }}"
        [suppressDefaultBackBehaviour]="suppressDefaultBackBehaviour"
        [suppressDefaultCloseBehaviour]="suppressDefaultCloseBehaviour"
        [topMenuVisibility]="newAccountMenuService.hideTopMenu('communication')"
        (onBack)="checkonback()"
        (onClose)="checkonclose()">
        <ng-container *ngTemplateOutlet="communicationTemplate"></ng-container>
    </lh-navigation-layout-page>
}
@if (source == 'crc') {
    <div class="portal-center-wrapper">
        @if (!device.isMobilePhone) {
            <div><br /></div>
        }
        <ng-container *ngTemplateOutlet="communicationTemplate"></ng-container>
    </div>
}
<ng-template #communicationTemplate>
    <div [ngClass]="{ 'portal-center-wrapper': newAccountMenuService.isCustomerHubEnabled() }">
        <vn-message-panel></vn-message-panel>
        <div class="portal-page width-restricted-small" id="communication" name="communication">
            @if (!isPromotionSwitchV2) {
                <div class="com_pre_padding10 font-14" [innerHtml]="initData.content.text | trustAsHtml"></div>
            }
            @if (isPromotionSwitchV2) {
                <div class="com_pre_padding10 font-14" [innerHtml]="initData.types.text | trustAsHtml"></div>
            }
            @if (initData.enableCommunicationProducts) {
                <div>
                    <div class="font-weight-bold pt-3" [vnDynamicHtml]="initData.communication.messages.ProductsHeading"></div>
                    <div class="comunication-products font-14">
                        <!-- This is deprecated comms-preference page is used instead -->
                        @for (communicationProduct of initData.communicationSettings.communicationProducts; track $index) {
                            <div [ngClass]="{ 'col-4': !device.isMobilePhone, 'col-5': device.isMobilePhone }">
                                <input
                                    class="custom-control-input custom-control-checkbox"
                                    id="{{ communicationProduct.name }}"
                                    name="{{ communicationProduct.name }}"
                                    type="checkbox"
                                    (change)="saveProductsManually(communicationProduct.name, $event.target.checked)"
                                    [(ngModel)]="communicationProduct.selected" />
                                <label class="font-weight-medium" for="{{ communicationProduct.name }}">
                                    {{ initData.types.messages[communicationProduct.name.toLowerCase()] }}</label
                                >
                            </div>
                        }
                    </div>
                    @if (showInfoMessage) {
                        <div class="message-panel">
                            <div class="theme-info-i">
                                <div class="cms-container" [vnDynamicHtml]="initData.communication.messages?.ProductsShowInfoMessage"></div>
                            </div>
                        </div>
                    }
                    <div
                        class="font-14"
                        [ngClass]="{ 'pt-3': !showInfoMessage }"
                        [vnDynamicHtml]="initData.communication.messages.ProductsContent"></div>
                </div>
            }
            @if (isMobileView && !isPromotionSwitchV2) {
                <div class="separator"></div>
            }
            <form #form="ngForm" class="form-base" (ngSubmit)="save()">
                @if (!isPromotionSwitchV2) {
                    <fieldset>
                        <legend class="font-weight-medium">{{ initData.content.messages['NewsletterGroupTitle'] }}</legend>
                        @if (initData.selectAllOptions) {
                            <div>
                                <input
                                    class="custom-control-input custom-control-checkbox"
                                    id="selectAllOptions"
                                    name="selectAllOptions"
                                    type="checkbox"
                                    (change)="SelectAllOptions()"
                                    [(ngModel)]="selectAll" />
                                <label class="font-weight-medium" for="selectAllOptions">{{ initData.content.messages['SelectAllOptions'] }}</label>
                            </div>
                        }
                        <div class="com_pre_padding10">
                            <div class="content-block d-flex flex-wrap form-elements-2-col">
                                @for (option of getUpdatedCoomunicationTypes(); track $index) {
                                    <div class="preference-type" [ngClass]="{ 'pt-2': device.isMobilePhone }">
                                        <div
                                            class="form-element checkboxtwoinline"
                                            [style.display]="option.name == 'RTToasterNotification' ? 'none' : 'block'">
                                            <input
                                                class="custom-control-input custom-control-checkbox"
                                                id="{{ option.name }}"
                                                name="{{ option.name }}"
                                                type="checkbox"
                                                (change)="validate(option.name, option.selected)"
                                                [(ngModel)]="option.selected" />
                                            <label class="font-weight-medium" for="{{ option.name }}">{{
                                                initData.types.messages[option.name]
                                            }}</label>
                                        </div>
                                    </div>
                                }
                            </div>
                            @if (showValidationAlert) {
                                <div class="validation-alert message-panel">
                                    <div class="theme-info-i">
                                        <div class="validation-message-div cms-container" [innerHtml]="AlertContent | trustAsHtml"></div>
                                    </div>
                                </div>
                            }
                            <div class="pc-txt preference-note" [innerHtml]="initData.content.messages['PreferenceNote'] | trustAsHtml"></div>
                        </div>
                    </fieldset>
                }
                @if (isPromotionSwitchV2) {
                    <fieldset>
                        @if (initData.selectAllOptions) {
                            <div class="switcher-lg float-right">
                                <label class="custom-control custom-checkbox custom-control-switcher">
                                    {{ allOptionsText }}
                                    <input
                                        class="custom-control-input"
                                        name="selectAllOptions"
                                        type="checkbox"
                                        (change)="SelectAllOptions()"
                                        [(ngModel)]="selectAll" />
                                    <span class="custom-control-switcher-lever switcher-position"></span>
                                </label>
                            </div>
                        }
                        <vn-loading-indicator></vn-loading-indicator>
                        <div class="com_pre_padding10 pt-5">
                            <div class="content-block form-elements">
                                @for (option of initData.communicationSettings.communicationTypes; track i; let i = $index) {
                                    <div class="preference-type">
                                        <div class="mb-2" id="opted-out-text">
                                            @if (option.name == 'Phone' && isPhoneOpted && isEmailOpted) {
                                                <div [innerHtml]="dividerText"></div>
                                            }
                                            @if (option.name == 'Phone' && isPhoneOpted && !isEmailOpted) {
                                                <div [innerHtml]="dividerText"></div>
                                            }
                                            @if (option.name == 'RegularMail' && !isPhoneOpted && isEmailOpted) {
                                                <div [innerHtml]="dividerText"></div>
                                            }
                                        </div>
                                        <div
                                            class="form-element checkboxtwoinline"
                                            [style.display]="option.name == 'RTToasterNotification' ? 'none' : 'block'">
                                            <div class="inlineblock">
                                                <div>
                                                    <label class="font-weight-medium font-weight-bold suggestion m-0" for="{{ option.name }}">{{
                                                        initData.types.messages[option.name]
                                                    }}</label>
                                                </div>
                                                <div>
                                                    <label class="font-weight-normal text">
                                                        {{ initData.suggestionText.messages[option.name] }}
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="switcher-lg inlineblock float-right">
                                                <label class="custom-control custom-checkbox custom-control-switcherr">
                                                    <input
                                                        class="custom-control-input"
                                                        type="checkbox"
                                                        [checked]="option.selected"
                                                        (change)="saveManually(option.name, $event.target.checked)" />
                                                    <span class="custom-control-switcher-lever switcher-position"></span>
                                                </label>
                                            </div>
                                        </div>
                                        @if (option.name != 'RTToasterNotification') {
                                            <div class="separator"></div>
                                        }
                                    </div>
                                }
                            </div>
                            @if (showValidationAlert && !isPromotionSwitchV2) {
                                <div class="validation-alert message-panel">
                                    <div class="theme-info-i">
                                        <div class="validation-message-div cms-container" [innerHtml]="AlertContent | trustAsHtml"></div>
                                    </div>
                                </div>
                            }
                            @if (!isPromotionSwitchV2) {
                                <div class="pc-txt preference-note" [innerHtml]="initData.content.messages['PreferenceNote'] | trustAsHtml"></div>
                            }
                        </div>
                    </fieldset>
                }
                @if (initData.isRTMSEnabled) {
                    <fieldset [style.display]="isContainsRTToasterNotification ? 'block' : 'none'">
                        <legend class="font-weight-medium">{{ initData.content.messages['NotificationsGroupTitle'] }}</legend>
                        <div class="com_pre_padding10">
                            <div class="content-block flexbox d-flex flex-wrap">
                                @for (option of initData.communicationSettings.communicationTypes; track $index) {
                                    <div>
                                        <div class="form-element" [style.display]="option.name != 'RTToasterNotification' ? 'none' : 'block'">
                                            <input
                                                class="custom-control-input custom-control-checkbox"
                                                id="{{ option.name }}"
                                                name="{{ option.name }}"
                                                type="checkbox"
                                                [(ngModel)]="option.selected" />
                                            <label class="font-weight-bold" for="{{ option.name }}">{{ initData.types.messages[option.name] }}</label>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </fieldset>
                }
                @if (!isPromotionSwitchV2 || initData.enableCommunicationProducts) {
                    <div class="full-content-block com_pre_padding10">
                        <button class="w-100" ds-button [disabled]="wait || disableSave">
                            {{ wait ? commonMessages['PleaseWait'] : commonMessages['Save'] }}
                        </button>
                        <div class="com_pre_paddingtop20" [innerHtml]="initData.content.messages['FooterNote'] | trustAsHtml"></div>
                    </div>
                }
            </form>
        </div>
    </div>
</ng-template>
